export default "__VITE_ASSET__ed6fddd2__"